module.exports = __webpack_public_path__ + "img/logos-fullname.1e5ddd92.svg";